<template>
  <!-- 下拉语言选择组件<lang></lang>,已全局注册-->
  <div class="langClass">
    <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click" @command="choose">
      <span class="language">
        &nbsp;
        {{label}}
        <i class="el-icon-caret-bottom" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="(item, key ,i) in messages" :key="i" :command="key">{{ item.language }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { messages } from '@/lang'
export default {
  props: ['active', 'toHome', 'toContact1'],
  name: 'topMenu',
  data() {
    return {
      messages: messages
      // 如果在非temlate模版中取多语言的值的话，去使用this.$t('xxx')
    }
  },
  computed: {
    label() {
      return this.$t('table.label')
    }
  },
  methods: {
    choose(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang) //存下用户选择的语言
      if (this.toHome === true && lang === 'en') {
        this.$router.push('home')
      }
      if (this.toContact1 === true && lang === 'en') {
        this.$router.push('contact-1')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.langClass {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  background-position: center;
  /* width: 5vw; */
  background: url('../../image/langIcon.png');
  background-size: contain;
  background-repeat: no-repeat;
  height: 3vw;
  width: 9vw;
  .language {
    cursor: pointer;
    color: #ffffff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/lang.vue